import { render, staticRenderFns } from "./bicoin_mobile.vue?vue&type=template&id=0ca22048&scoped=true&"
import script from "./bicoin_mobile.vue?vue&type=script&lang=js&"
export * from "./bicoin_mobile.vue?vue&type=script&lang=js&"
import style0 from "./bicoin_mobile.vue?vue&type=style&index=0&id=0ca22048&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ca22048",
  null
  
)

export default component.exports